import { Component } from '@angular/core';

@Component({
  selector: 'app-main-conference24',
  templateUrl: './main-conference24.component.html',
  styleUrl: './main-conference24.component.css'
})
export class MainConference24Component {

}
